import { appConfig } from 'cd-eft/config/AppConfig';
import * as EFH2 from 'cd-eft/_codegen_/openapi-generator/eft-efh2';
import axios from 'axios';
import { EftAuthAxiosInterceptor } from './EftAuthAxiosInterceptor';
import { UserIdentity } from 'cd-eft/security/UserIdentity';

const apiConfig = new EFH2.Configuration({ basePath: appConfig.endpoints.eftEfh2ApiBasePath });

const axiosInstance = axios.create();

export const Efh2ControllerApi = new EFH2.Efh2ControllerApi(apiConfig, undefined, axiosInstance);
export const HydroControllerApi = new EFH2.HydroControllerApi(apiConfig, undefined, axiosInstance);
export const ServiceStatusController = new EFH2.ServiceStatusControllerApi(apiConfig);
export const HydroTcVelocityController = new EFH2.HydroTcVelocityControllerApi(apiConfig, undefined, axiosInstance);

// create and activate the EftAuthAxiosInterceptor
const __eftAuthAxiosInterceptor = new EftAuthAxiosInterceptor(axiosInstance, UserIdentity);
__eftAuthAxiosInterceptor.activate();

// console.log('!!!! EFT-EFH2 API INITIALIZED !!!!');
